import { TeamMemberFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import ListItemHeading from '../../../components/ListItemHeading';
import { Paragraph } from '../../../components/Text';

import style from './team-member-dialog-content.module.css';

interface TeamMemberDialogContentProps {
  member: TeamMemberFragmentFragment;
}

const TeamMemberDialogContent = ({
  member,
}: TeamMemberDialogContentProps) => {
  const memberJobTitles = (member.jobTitleInDialog ?? '').split('\n').map(jt => jt.trim()).filter(Boolean);
  const bioParagraphs = (member.bio ?? '').split('\n').map(b => b.trim()).filter(Boolean);

  return (
    <div className={style.teamMemberDialogContent}>
      {member.headshot && (
        <AppImage
          className={style.headshot}
          fallbackHeight={400}
          fallbackWidth={400}
          image={member.headshot}
        />
      )}

      <div className={style.memberMetadata}>
        {member.name && (
          <ListItemHeading fontColor="black">
            {member.name}
          </ListItemHeading>
        )}

        {memberJobTitles.map(jobTitle => (
          <Paragraph key={jobTitle}>
            {jobTitle}
          </Paragraph>
        ))}
      </div>

      {bioParagraphs.map((paragraph, index) => (
        <Paragraph
          className={style.bio}
          fontSize={15}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
        >
          {paragraph}
        </Paragraph>
      ))}
    </div>
  );
};

export default TeamMemberDialogContent;
